


















import {Component, Emit, Prop, Vue, Watch} from "vue-property-decorator";
import { TaskContent } from "../../Classes/Entities/Chat/TaskContent";

@Component
export default class TaskThreadOverview extends Vue {
  @Prop() 
  public taskContent!:TaskContent;
  @Prop() 
  public functionId!: string;

  public created() {
    setTimeout(() => {
      const lastChild:Element|null = document.querySelector('ul.c-list li:last-child');
      if (lastChild != null) {
        lastChild.scrollIntoView(true);
      }
    }, 150)
  }

  public get threadList() {
    return this.taskContent.postList.sortedList;
  }

  @Watch('taskContent.postList.threadList')
  onChange(nw: any, old: any) {
    setTimeout(() => {
      const lastChild:Element|null = document.querySelector('ul.c-list li.c-list__item-wrap--roundwhite:last-child');
      if (lastChild != null) {
        lastChild.scrollIntoView(true);
      }
    }, 100)
  }
}
